<template>
  <div class="flex-child">
    <div class="body-container">
      <iframe :src="iframeSrc" style="width:100%; height:90vh; border:none; border-radius: 20px;"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerInformation",
  data() {
    return {
      rawHtml: "",
    };
  },
  computed: {
    iframeSrc() {
      const authToken = this.$route.query.AuthToken || localStorage.getItem('authToken');
      if (authToken) {
        return `/skohagen.html?AuthToken=${authToken}`;
      }
      return '/skohagen.html';
    }
  },
  async mounted() {
    // load the external HTML file from /public
    const res = await fetch("/skohagen.html");
    this.rawHtml = await res.text();
  },
};
</script>

<style scoped>
.body-container {
  min-height: 80vh;
  min-width: 93vw;
  padding: 0;
}
</style>